module.exports = __webpack_public_path__ + "img/4.ec2c73e9.png";